/* eslint-disable @typescript-eslint/no-unused-expressions */
import { energyApi } from "utilities/Axios";

export const getTrains = () => {
  return energyApi.get(`/TagMeta/GetTrainsByPlantId?id=${1}`);
};

export const getAllTrains = () => {
  return energyApi.get(`/TagMeta/GetAllTrains`);
};

export const createTrain = (train: any) => {
  return energyApi.post("/TagMeta/CreateTrain", train);
};

export const updateTrain = (train: any) => {
  return energyApi.post("/TagMeta/UpdateTrain", train);
};

export const deleteTrain = (id: number) => {
  return energyApi.get(`/TagMeta/DeleteTrain?id=${id}`);
};
